import React from 'react';
import PropTypes from 'prop-types';

import './Label.scss';

const Label = ({ labelClass, children, htmlFor, helperText, extraStyle, callingComponent }) => {
  const finalSpanClass = callingComponent ? ("main-label mandatory-field") : "main-label";
  return (
    <label
      htmlFor={htmlFor}
      className={labelClass}
      style={extraStyle}
    >
      <span className={finalSpanClass}>{children}</span>
      {
        helperText.length > 0 &&
        <span className="label-helper-text">{helperText}</span>
      }
    </label>
  );
};

Label.propTypes = {
  htmlFor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]),
  helperText: PropTypes.string,
  labelClass: PropTypes.string,
};

Label.defaultProps = {
  labelClass: 'field-label',
  children: '',
  helperText: '',
  extraStyle: {},
};

export default Label;
